import DesignBoxConfirmationRow from "./DesignBoxConfirmationRow";
import styles from "./DesignBoxConfirmationTable.module.css";

const DesignBoxConfirmationTable = ({ items }) => {
  return (
    <>
      {items && items.length > 0 && (
        <>
          <div className={styles.top_text}>
            完成デザイン表示日から1週間以内に「デザイン確定」または「修正希望」のボタンを押してください。変更受付期限以降は、修正はできませんのでご了承ください。
          </div>
          <div className={styles.main_div}>
            {items.length > 0 && <div className={styles.hr} />}
            <div className={styles.all_rows}>
              {Array.isArray(items) &&
                items.length > 0 &&
                items.map((item, index) => (
                  <DesignBoxConfirmationRow key={index} item={item} />
                ))}
            </div>
          </div>
        </>
      )}
      {items && items.length === 0 && (
        <div>
          <div
            className={styles.top_text}
            style={{
              textAlign: "center",
              marginTop: "50px",
              marginBottom: "50px",
            }}
          >
            以下のアイテムをご購入の場合は、入稿後、完成デザイン確認があります。
            <br />
            未編集の場合は編集・入稿をお済ませください。
          </div>
          <div className={styles.confirmNoItemGreyCard}>
            アルバム・木製プレート・木製デザインプレート
            <br />
            二面台紙・三面台紙
            <br />
            キャンバスフォト・パーツフォト・年賀状
          </div>
          <p className={styles.confirmNoItemBottomTxt}>
            上記アイテム以外の完成デザイン確認はありません。
          </p>
        </div>
      )}
    </>
  );
};

export default DesignBoxConfirmationTable;
